import React from 'react';
import { FormControl, FormLabel, MenuItem, Select } from '@mui/material';

export const Dropdown = (props) => {
	const { name, value, disabled, source, onChange, label } = props;
	const dataAttrs = Object.keys(props).reduce((accum, key) => {
		if (key.startsWith('data-')) {
			accum[key] = props[key];
		}

		return accum;
	}, {});

	return (
		<FormControl fullWidth>
			<FormLabel id={`${name}-label`}>{label}</FormLabel>
			<Select
				size="small"
				name={name}
				aria-labelledby={`${name}-label`}
				value={value || ''}
				disabled={disabled}
				onChange={(event) => onChange(event.target.value)}
				{...dataAttrs}
			>
				{source.map((item) => (
					<MenuItem key={item.value} value={item.value}>
						{item.label}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};
